let idCount = 0;

function uniqueId(prefix) {
	return (prefix ? prefix : '') + ++idCount;
}

export default uniqueId;
